import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { PileRenamerPage } from './pile-renamer/pile-renamer.page';
import { PileSaverPage } from './pile-saver/pile-saver.page';

@Component({
  selector: 'app-pile-editor',
  templateUrl: './pile-editor.component.html',
  styleUrls: ['./pile-editor.component.scss'],
})
export class PileEditorComponent implements OnInit {
  public form:FormGroup;
  _pile:any;
  @Input() teams:string[]=[]
  @Input() roads:string[]=[];
  @Input() operations:string[]=[];
  @Input() pileNumbers:string[] =[];
  @Input() visible:boolean =false;
  @Output() deletePile:EventEmitter<string> = new EventEmitter<string>();
  @Output() renamePile:EventEmitter<any> = new EventEmitter<any>();
  @Output() savePile:EventEmitter<any> = new EventEmitter<any>();
  essences:string[]="010 030 060 043 105 190 191 199".split(' ');
  @Output()
  get value(){
    return this._pile;
  }

  @Input()
  set pile( value: any ){
    if(!value){
      this._pile = undefined;
      return;
    }
    let json = value.toJSON();
    ['created','modified','transported'].forEach( (timeprop:string)=>{
      if(json.hasOwnProperty(timeprop)){
        json[timeprop] = json[timeprop] ? new Date(json[timeprop]) : json[timeprop];
      }
    })
    this._pile = json;
    this.reset();

    // console.log(json)
  }
  toggleDebug(el:any){
    el.el.classList.toggle('debug');
    // console.log('toggleDebug', el);
  }
  async reset(){
    this.form.controls['road'].setValue(this._pile.road);
    this.form.controls['team'].setValue(this._pile.team);
    this.form.controls['essence'].setValue(this._pile.essence?.code);
    this.form.controls['operation'].setValue(this._pile.operation||this._pile.meta?.operation);
    this.form.controls['status'].setValue(this._pile.status);
    this.form.controls['created'].setValue(this._pile.created);
    this.form.controls['modified'].setValue(this._pile.modified);
    this.form.controls['transported'].setValue(this._pile.transported);
    this.form.controls['logLength'].setValue(this._pile.measures?.logLength);
    this.form.controls['length'].setValue(this._pile.measures?.length);
    let h = this._pile.measures?.heights.reduce( (t:number,n:number)=>{ return t+n},0)/this._pile.measures?.heights?.length;
    if(!isNaN(h)){
      this.form.controls['height'].setValue(Number(h.toFixed(2)));
    }
    this.setDateDisabledStates({value:this._pile.status})

  }
  computeItemClass(e:any){
    console.log('computeItemClass',e)
  }
setDateDisabledStates(stateInput:any){
  const value = stateInput.value;
  // const modEl:any = document.querySelector('[formControlName="modified"]').parentNode;
  // const transEl:any = document.querySelector('[formControlName="transported"]').parentNode;

  if(value == 'new' || value =='inventory'){
    this.form.controls['created'].enable();
    this.form.controls['modified'].disable();
    this.form.controls['transported'].disable();
    // modEl.hidden = true;
    // transEl.hidden = true;

  }else if(value =='modified'){
    this.form.controls['created'].enable();
    this.form.controls['modified'].enable();
    this.form.controls['transported'].disable();
    // modEl.hidden = false;
    // transEl.hidden = true;
  }else if(value == 'transported'){
    this.form.controls['created'].enable();
    this.form.controls['modified'].enable();
    this.form.controls['transported'].enable();
    // modEl.hidden = false;
    // transEl.hidden = false;
  }
}

async openRenamer(pileNumber:string,uid:string){

    const modal = await this.modalController.create({
      component: PileRenamerPage,
      cssClass: 'pile-renamer-modal',
      componentProps: {
        pileNumber: pileNumber,
        uid: uid,
        pileNumbers: this.pileNumbers
      }
    });
    await modal.present();
    const  {data} = await modal.onWillDismiss();
    if(data && data.changed){
      console.log('emits renamepile')
      this.renamePile.emit( data );
    }
}

async confirmDelete(pileNumber:string,uid:string){

   const alert = await this.alertController.create({
     cssClass: 'my-custom-class',
     header: 'Confirmer!',
     message: `Voulez vous vraiment effacer la pile #<strong>${pileNumber}</strong>?`,
     backdropDismiss: false,
     buttons: [
       {
         text: 'Non',
         role: 'cancel',
         cssClass: 'secondary',
         handler: () => {
           return;
         }
       }, {
         text: 'Oui',
         handler: () => {
           this.deletePile.emit(uid);
           console.log('emit deletePile', uid)
         }
       }
     ]
   });

   await alert.present();


}
async openSaver(){
  const props = {original:this._pile,data:this.form.value};
  const modal = await this.modalController.create({
    component: PileSaverPage,
    cssClass: 'pile-saver-modal',
    componentProps: props
  });
  await modal.present();
  const  {data} = await modal.onWillDismiss();
  if(data && data.confirmed){
    this.savePile.emit(  props );
  }

}
  constructor( private formBuilder: FormBuilder,public alertController: AlertController,public modalController: ModalController ) {
    this.form = this.formBuilder.group({
      road: ['', Validators.required],
      team: ['', Validators.required],
      essence: ['', Validators.required],
      operation: ['', Validators.required],
      status: ['', Validators.required],
      created: ['', Validators.required],
      modified: ['', Validators.required],
      transported: ['', Validators.required],
      logLength: ['', Validators.required],
      length: ['', Validators.required],
      height: ['', Validators.required],
    })

  }
  public findInvalidControls() {
      const invalid = [];
      const controls = this.form.controls;
      for (const name in controls) {
          if (controls[name].invalid) {
              invalid.push(controls[name]);
          }
      }
      return invalid;
  }
  ngOnInit() {}

}
